"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Tile_1 = __importDefault(require("ol/layer/Tile"));
const source_1 = require("ol/source");
class MapLayer {
    constructor(provider, apikey) {
        this.provider = provider;
        this.apikey = apikey;
    }
    get layers() {
        let source;
        let sourceRoad;
        if (this.provider === 'BingMaps') {
            source = new source_1.BingMaps({
                key: this.apikey,
                imagerySet: 'AerialWithLabels',
            });
        }
        else if (this.provider === 'AzureMaps') {
            source = new source_1.XYZ({
                url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${this.apikey}`,
                tileSize: 256
            });
            sourceRoad = new source_1.XYZ({
                url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.base.labels.road&zoom={z}&x={x}&y={y}&subscription-key=${this.apikey}`,
                tileSize: 256
            });
        }
        else {
            source = new source_1.OSM();
        }
        const layerBase = new Tile_1.default({ source: source, preload: Infinity });
        layerBase.set('id', 'base-layer');
        layerBase.setZIndex(0);
        const layerRoad = new Tile_1.default({ source: sourceRoad, preload: Infinity });
        layerRoad.set('id', 'base-layer-road');
        layerRoad.setZIndex(1);
        if (this.provider === 'AzureMaps') {
            return [layerBase, layerRoad];
        }
        else {
            return [layerBase];
        }
    }
}
exports.default = MapLayer;
